import React from "react";
import OPOfflineIframe from "../../../iframe-component/operation-offline/OPOffIframe";

const AddOfflineEmployee = ({ path }) => {
  return <OPOfflineIframe path="/employee/create" statePath={path} />;
};

export default React.memo(AddOfflineEmployee);
